import CRUD from './crud'

export default new CRUD('categories', 'superior-judge')
